(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-trustpilot-slider"] && !Shopify.designMode) return;
  try {
    
  /* Laadt Trustpilot's bootstrap één keer, pas ná de eerste paint en pas als een sectie
     binnen `data-load-margin` px van de viewport komt. Het script is async: nooit
     render-blocking. Zonder IntersectionObserver (oude browsers): laden op DOMContentLoaded. */
  (function () {
    var SRC = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    var requested = false;

    function loadBootstrap() {
      if (requested) return;
      requested = true;
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        var els = document.querySelectorAll('.custom-tp-slider__widget');
        for (var i = 0; i < els.length; i++) {
          if (!els[i].querySelector('iframe')) window.Trustpilot.loadFromElement(els[i], true);
        }
        return;
      }
      var sc = document.createElement('script');
      sc.src = SRC;
      sc.async = true;
      document.head.appendChild(sc);
    }

    function arm() {
      var sections = document.querySelectorAll('[data-custom-tp-slider]');
      if (!sections.length) return;
      if (!('IntersectionObserver' in window)) { loadBootstrap(); return; }
      var margin = parseInt(sections[0].getAttribute('data-load-margin'), 10) || 600;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); loadBootstrap(); return; }
        }
      }, { rootMargin: margin + 'px 0px' });
      for (var j = 0; j < sections.length; j++) io.observe(sections[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arm);
    } else {
      arm();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      
      // Debug logging
      console.log("Recommendations response received");
      var newContent = container.querySelector(".related-products");
      if (newContent) {
        console.log("Found related products in response");
        productRecommendationsSection.innerHTML = newContent.innerHTML;
        
        // Check how many product elements are actually rendered
        var productElements = productRecommendationsSection.querySelectorAll('.product-block, .product-detail');
        console.log("Rendered " + productElements.length + " product elements");
      } else {
        console.log("No related products found in response");
        console.log("Full response:", request.response);
      }
    } else {
      console.log("Request failed with status: " + request.status);
    }
  };
  
  request.onerror = function() {
    console.log("Request failed to complete");
  };
  
  request.send();
};

// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function() {
  // Small delay to ensure page is fully loaded
  setTimeout(loadProductRecommendationsIntoSection, 500);
});

// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stane-bundle-compare"] && !Shopify.designMode) return;
  try {
    
  class StaneBundleCompare extends HTMLElement {
    #mediaQuery = null;
    #mediaQueryHandler = null;

    connectedCallback() {
      this.viewport = this.querySelector('[data-stane-compare-viewport]');
      if (!this.viewport) return;

      // Premium-anchor doctrine: op mobiel (≤1023px) scrolt de viewport naar de anchor-kolom
      // bij eerste laad zodat Premium meteen zichtbaar is.
      this.#mediaQuery = window.matchMedia('(max-width: 1023px)');
      if (this.#mediaQuery.matches) {
        this.#scrollToAnchor();
      }

      // Re-scroll wanneer viewport wisselt (orientation change e.d.)
      this.#mediaQueryHandler = (e) => {
        if (e.matches) this.#scrollToAnchor();
      };
      this.#mediaQuery.addEventListener('change', this.#mediaQueryHandler);
    }

    disconnectedCallback() {
      if (this.#mediaQuery && this.#mediaQueryHandler) {
        this.#mediaQuery.removeEventListener('change', this.#mediaQueryHandler);
      }
    }

    #scrollToAnchor() {
      const anchor = this.viewport.querySelector('[data-anchor-column="true"]');
      if (!anchor) return;
      // scrollLeft direct setten = altijd instant, in elke browser.
      // (scrollTo({behavior:'instant'}) is niet in de spec — wordt afgehandeld als 'auto'.)
      requestAnimationFrame(() => {
        this.viewport.scrollLeft = anchor.offsetLeft;
      });
    }
  }
  customElements.define('stane-bundle-compare', StaneBundleCompare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stane-bundle-hero"] && !Shopify.designMode) return;
  try {
    
  class StaneBundleHeroController extends HTMLElement {
    connectedCallback() {
      const sectionId = this.dataset.sectionId;
      const section = document.querySelector(`.stane-bundle-hero[data-section-id="${sectionId}"]`);
      if (!section) return;

      const dataEl = document.querySelector(`script[data-stane-bundle-hero-product="${sectionId}"]`);
      if (!dataEl) return;
      try {
        this.productData = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn('stane-bundle-hero: kon productdata niet parsen', e);
        return;
      }

      this.section = section;
      this.form = section.querySelector('.stane-bundle-hero__form');
      if (!this.form) return;

      this.variantIdInput = this.form.querySelector('[data-variant-id-input]');
      this.priceEl = section.querySelector('[data-variant-price]');
      this.ctaPriceEl = section.querySelector('[data-stane-cta-price]');
      this.bundleChairEl = section.querySelector('[data-stane-bundle-chair]');
      this.bundleDeskEl = section.querySelector('[data-stane-bundle-desk]');
      this.optionInputs = Array.from(this.form.querySelectorAll('[data-option-input]'));

      this.optionInputs.forEach((el) => el.addEventListener('change', this.#onOptionChange.bind(this)));

      this.#applyDefaultSize();
      // Initial render of JOUW BUNDEL summary
      this.#updateBundleSummary();
    }

    #applyDefaultSize() {
      const defaultSize = (this.form.dataset.defaultSize || '').trim();
      if (!defaultSize) return;

      const sizeOption = this.productData.options.findIndex((opt) =>
        /maat|size|bureau/i.test(opt)
      );
      if (sizeOption === -1) return;

      // Normalise both sides for comparison: lowercase, drop spaces, swap × ↔ x
      const norm = s => (s || '').toString().toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '');
      const want = norm(defaultSize);

      const inputs = this.form.querySelectorAll(`[data-option-position="${sizeOption + 1}"] input[data-option-input]`);
      for (const input of inputs) {
        if (norm(input.value) === want) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    }

    #onOptionChange() {
      const selected = Array.from(this.form.querySelectorAll('[data-option-input]:checked'))
        .sort((a, b) => Number(a.closest('[data-option-position]').dataset.optionPosition)
                       - Number(b.closest('[data-option-position]').dataset.optionPosition))
        .map((el) => el.value);

      const variant = this.productData.variants.find((v) =>
        v.options.every((opt, i) => opt === selected[i])
      );
      if (!variant) return;

      const formatted = this.#formatMoney(variant.price);

      if (this.variantIdInput) this.variantIdInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = formatted;
      if (this.ctaPriceEl) this.ctaPriceEl.textContent = formatted;

      this.#updateBundleSummary();

      document.dispatchEvent(new CustomEvent('stane:variant-changed', {
        detail: {
          variantId: variant.id,
          price: variant.price,
          formattedPrice: formatted,
        },
        bubbles: true,
      }));
    }

    #updateBundleSummary() {
      // Map option values to either chair-line or desk-line based on heuristic:
      // - Stoelvulling (mesh/foam/schuim) → chair
      // - Bureaumaat (cm) → desk
      // - Bureaukleur (eiken/wit) → desk
      const selected = this.optionInputs.filter(i => i.checked);
      const chairParts = [];
      const deskParts = [];
      for (const input of selected) {
        const v = (input.value || '').trim();
        const lower = v.toLowerCase();
        if (lower.includes('mesh') || lower.includes('foam') || lower.includes('schuim')) {
          chairParts.push(v);
        } else {
          deskParts.push(v);
        }
      }
      if (this.bundleChairEl) this.bundleChairEl.textContent = chairParts.length ? '— ' + chairParts.join(' / ') : '—';
      if (this.bundleDeskEl)  this.bundleDeskEl.textContent  = deskParts.length  ? deskParts.join(' / ')      : '—';
    }

    #formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        try { return window.Shopify.formatMoney(cents); } catch (e) { /* fall through */ }
      }
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    }
  }
  customElements.define('stane-bundle-hero-controller', StaneBundleHeroController);

  class StaneBundleUpsells extends HTMLElement {
    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('[data-stane-upsell-input]'));
      this.handler = this.#onChange.bind(this);
      this.inputs.forEach(i => i.addEventListener('change', this.handler));
    }
    disconnectedCallback() {
      this.inputs?.forEach(i => i.removeEventListener('change', this.handler));
    }
    #onChange(e) {
      const input = e.target;
      const handle = input.dataset.productHandle;
      const variantId = input.dataset.variantId;
      const checked = input.checked;
      // Visual-only voor sessie 2-deel-1; cart-add multi-line items komt later.
      console.log('[stane-upsell]', checked ? 'selected' : 'deselected', handle, 'variant=' + variantId);
      // Dispatch event for future hookup met cart-add
      document.dispatchEvent(new CustomEvent('stane:upsell-toggled', {
        detail: { handle, variantId, checked },
        bubbles: true,
      }));
    }
  }
  customElements.define('stane-bundle-upsells', StaneBundleUpsells);

  class StaneBundleHeroGallery extends HTMLElement {
    connectedCallback() {
      this.mainImg = document.getElementById(this.dataset.mainImageId);
      this.thumbs = Array.from(this.querySelectorAll('[data-stane-thumb]'));
      this.handler = this.#onThumbClick.bind(this);
      this.thumbs.forEach(t => t.addEventListener('click', this.handler));
    }
    disconnectedCallback() {
      this.thumbs?.forEach(t => t.removeEventListener('click', this.handler));
    }
    #onThumbClick(e) {
      const btn = e.currentTarget;
      const fullSrc = btn.dataset.fullSrc;
      if (!fullSrc || !this.mainImg) return;
      // Remove srcset om naar de full-src te switchen zonder responsive logic-conflict
      this.mainImg.removeAttribute('srcset');
      this.mainImg.removeAttribute('sizes');
      this.mainImg.src = fullSrc;
      this.thumbs.forEach(t => t.classList.toggle('is-active', t === btn));
    }
  }
  customElements.define('stane-bundle-hero-gallery', StaneBundleHeroGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stane-bundle-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  class StaneBundleStickyCta extends HTMLElement {
    #observer = null;
    #variantHandler = null;

    connectedCallback() {
      const selector = this.dataset.watchSelector || '[data-stane-main-cta]';
      const target = document.querySelector(selector);

      if (target && 'IntersectionObserver' in window) {
        this.#observer = new IntersectionObserver(([entry]) => {
          this.#setVisible(!entry.isIntersecting);
        }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
        this.#observer.observe(target);
      } else {
        const onScroll = () => this.#setVisible(window.scrollY > 600);
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      this.#variantHandler = this.#onVariantChange.bind(this);
      document.addEventListener('stane:variant-changed', this.#variantHandler);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      if (this.#variantHandler) {
        document.removeEventListener('stane:variant-changed', this.#variantHandler);
      }
    }

    #setVisible(visible) {
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    #onVariantChange(event) {
      const detail = event.detail;
      if (!detail) return;
      const idInput = this.querySelector('[data-variant-id-input]');
      const priceEl = this.querySelector('[data-variant-price]');
      if (idInput && detail.variantId) idInput.value = detail.variantId;
      if (priceEl && detail.formattedPrice) priceEl.textContent = detail.formattedPrice;
    }
  }
  customElements.define('stane-bundle-sticky-cta', StaneBundleStickyCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stane-bundle-ugc"] && !Shopify.designMode) return;
  try {
    
  class StaneBundleUgcTile extends HTMLElement {
    /* Reserved for future modal logic */
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('[data-stane-ugc-tile]');
    if (!btn) return;
    e.preventDefault();
    console.log('[stane-ugc] open video', { customer: btn.dataset.customer, url: btn.dataset.videoUrl });
    document.dispatchEvent(new CustomEvent('stane:ugc-open', {
      detail: { customer: btn.dataset.customer, url: btn.dataset.videoUrl },
      bubbles: true,
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stane-v3-hero"] && !Shopify.designMode) return;
  try {
    
  class StaneV3HeroController extends HTMLElement {
    connectedCallback() {
      this.section = this;

      // Image gallery
      this.mainImg = document.getElementById('StaneV3HeroMainImg-' + this.dataset.sectionId);
      this.thumbs = Array.from(this.querySelectorAll('[data-stane-v3-thumb]'));
      this.thumbs.forEach(t => t.addEventListener('click', this.#onThumbClick.bind(this)));

      // Pricing controls
      this.basePriceCents = parseInt(this.querySelector('[data-stane-v3-cta]')?.dataset.basePriceCents || '0', 10);
      this.heroMainPriceEls = this.querySelectorAll('[data-stane-v3-total-price]');
      this.ctaPriceEls = this.querySelectorAll('[data-stane-v3-cta-price]');
      this.exclBtwEl = this.querySelector('[data-stane-v3-price-excl]');
      this.heroCompareEl = this.querySelector('[data-stane-v3-hero-compare]');
      this.heroSavingsEl = this.querySelector('[data-stane-v3-hero-savings]');
      this.heroCapBlock = this.querySelector('[data-stane-v3-hero-cap-block]');
      this.sizeButtons = Array.from(this.querySelectorAll('[data-stane-v3-size]'));
      this.chairButtons = Array.from(this.querySelectorAll('[data-stane-v3-chair]'));
      this.upsellInputs = Array.from(this.querySelectorAll('[data-stane-v3-upsell]'));

      // Variants — bron van waarheid voor variant-id + variant.price
      const variantsScript = this.querySelector('[data-stane-v3-variants]');
      try {
        this.variants = variantsScript ? JSON.parse(variantsScript.textContent.trim()) : [];
      } catch (e) {
        console.warn('[stane-v3-hero] variants parse failed:', e);
        this.variants = [];
      }
      this.variantIdInput = this.querySelector('[data-stane-v3-variant-id]');
      this.activeVariant = null;

      // Bundels V2 (Task 5): Blad/Frame/Maat-knoppen; de JSON bevat alleen echte varianten.
      // Zonder [data-stane-v3-v2] (de oude bundels) blijft this.v2 null en loopt alles zoals voorheen.
      this.v2 = null;
      const v2El = this.querySelector('[data-stane-v3-v2]');
      if (v2El) {
        try {
          const v2 = JSON.parse(v2El.textContent.trim());
          if (v2 && Array.isArray(v2.varianten) && v2.varianten.length) this.v2 = v2;
        } catch (e) {
          console.warn('[stane-v3-hero] v2 parse failed:', e);
        }
      }
      if (this.v2) {
        const startId = parseInt(this.variantIdInput?.value || '0', 10);
        this.v2Actief = this.v2.varianten.find(v => v.id === startId) || this.v2.varianten[0];
        // De keuze (wat de knoppen tonen) kan een niet-koopbare combinatie zijn; v2Koopbaar = echt + available
        // (StaneBundelKeuze.koopbaar). Niet koopbaar → CTA aria-disabled en geen POST (eindreview I1).
        this.v2Keuze = { maat: this.v2Actief.maat, blad: this.v2Actief.blad, frame: this.v2Actief.frame };
        this.v2Koopbaar = this.v2Actief.available === true && this.v2.bestaand.indexOf(this.v2Actief.maat + '|' + this.v2Actief.blad + '|' + this.v2Actief.frame) !== -1;
        const meldData = this.querySelector('[data-stane-v3-melding]')?.dataset || {};
        this.v2Teksten = { vanaf: meldData.tekstVanaf || '', nietLeverbaar: meldData.tekstNietLeverbaar || '' };
        this.querySelectorAll('[data-stane-v3-optie] [data-waarde]').forEach(b => b.addEventListener('click', this.#v2Klik.bind(this)));
      }

      // Chair-CAP wordt 1x bij mount uit het bundle-contents-DOM gelezen (statisch)
      const chairCapEl = document.querySelector('[data-stane-chair-cap]');
      this.chairCapCents = chairCapEl ? this.#parseMoneyToCents(chairCapEl.textContent) : 0;

      this.sizeButtons.forEach(b => b.addEventListener('click', this.#onSizeClick.bind(this)));
      this.chairButtons.forEach(b => b.addEventListener('click', this.#onChairClick.bind(this)));
      this.upsellInputs.forEach(i => i.addEventListener('change', () => this.#recalcPrice()));

      // Trustpilot wrapper → smooth-scroll naar #reviews (snippet's eigen handler
      // zoekt #stane-reviews wat niet bestaat; deze handler vangt de bubble)
      const tp = this.querySelector('[data-stane-v3-tp-link]');
      if (tp) {
        const scrollToReviews = (e) => {
          const target = document.getElementById('reviews');
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        };
        tp.addEventListener('click', scrollToReviews);
        tp.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { scrollToReviews(e); }
        });
      }

      this.#syncVariant();
      this.#recalcPrice();
      this.#updateBundleContents();

      // Triple-defense cart submit — scope-guarded binnen deze custom element
      const cartForm = this.querySelector('[data-stane-v3-cart-form]');
      const cartCta = this.querySelector('[data-stane-v3-cta]');
      if (cartForm) {
        cartForm.addEventListener('submit', this.#handleSubmit.bind(this), { capture: true });
      }
      if (cartCta) {
        cartCta.addEventListener('click', this.#handleSubmit.bind(this), { capture: true });
      }
      if (cartForm && !cartForm.__staneOverridden) {
        cartForm.__staneOverridden = true;
        cartForm.submit = () => {
          this.#handleSubmit({ preventDefault: () => {}, stopImmediatePropagation: () => {}, target: cartForm });
        };
      }
    }

    #getActiveLabels() {
      const chair = this.chairButtons.find(b => b.classList.contains('is-active'));
      const size = this.sizeButtons.find(b => b.classList.contains('is-active'));
      return {
        chair: chair?.dataset.chairLabel?.trim() || null,
        size: size?.dataset.deskLabel?.trim() || null,
      };
    }

    #resolveVariant() {
      if (this.v2) return this.v2Actief || null;
      if (!this.variants?.length) return null;
      if (this.variants.length === 1) return this.variants[0];
      const { chair, size } = this.#getActiveLabels();

      // Verzamel alle daadwerkelijke option-waarden uit de variants
      // Pills met een label dat NIET in deze set zit (bv. 'Standaard' placeholder,
      // of een UI-label dat afwijkt van Shopify's option-naam) worden genegeerd —
      // anders matcht de find() niets en valt het systeem terug op default.
      if (!this._optionValueSet) {
        const set = new Set();
        for (const v of this.variants) {
          for (const o of [v.option1, v.option2, v.option3]) if (o) set.add(o);
        }
        this._optionValueSet = set;
      }
      const isPlaceholder = (l) => !l || l === 'Default Title' || l === 'default' || l === 'Standaard';
      const chairMatters = !isPlaceholder(chair) && this._optionValueSet.has(chair);
      const sizeMatters = !isPlaceholder(size) && this._optionValueSet.has(size);

      if (!chairMatters && !sizeMatters) return this.variants[0];

      const match = this.variants.find(v => {
        const options = [v.option1, v.option2, v.option3];
        const matchesChair = !chairMatters || options.includes(chair);
        const matchesSize = !sizeMatters || options.includes(size);
        return matchesChair && matchesSize;
      });

      if (!match) {
        console.warn('[stane-v3-hero] geen variant-match voor', { chair, size, chairMatters, sizeMatters });
        return this.variants[0];
      }
      return match;
    }

    #syncVariant() {
      const variant = this.#resolveVariant();
      this.activeVariant = variant;
      // V2: een niet-koopbare keuze schrijft geen id (prijs en beeld volgen wel): de CTA staat dan uit
      // en #handleSubmit post niets (eindreview I1).
      if (this.v2 && !this.v2Koopbaar) return;
      if (variant && this.variantIdInput) {
        this.variantIdInput.value = variant.id;
      }
      // V2: ook het reserve-formulier van de sticky balk (fallback-submit) krijgt de echte variant.
      if (this.v2 && variant) {
        document.querySelectorAll('[data-stane-v3-sticky-form] [name="id"]').forEach(i => { i.value = variant.id; });
      }
    }

    #onThumbClick(e) {
      const btn = e.currentTarget;
      const src = btn.dataset.fullSrc;
      if (!src || !this.mainImg) return;
      this.mainImg.removeAttribute('srcset');
      this.mainImg.removeAttribute('sizes');
      this.mainImg.src = src;
      this.thumbs.forEach(t => t.classList.toggle('is-active', t === btn));
    }

    // V2: klik op Blad/Frame/Maat → kiesVariant (bundels-v2-keuze.js). Een uitgegrijsde maat doet niets.
    #v2Klik(e) {
      const btn = e.currentTarget;
      if (btn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      const K = window.StaneBundelKeuze;
      if (!K || !this.v2Actief) return;
      const groep = btn.closest('[data-stane-v3-optie]')?.dataset.staneV3Optie;
      const veld = groep === 'afmeting' ? 'maat' : groep;
      if (veld !== 'maat' && veld !== 'blad' && veld !== 'frame') return;
      const keuze = { maat: this.v2Keuze.maat, blad: this.v2Keuze.blad, frame: this.v2Keuze.frame };
      keuze[veld] = btn.dataset.waarde;
      const r = K.kiesVariant(this.v2.varianten, this.v2.bestaand, keuze, this.v2Teksten);
      if (!r) return;
      // Niet koopbaar: de keuze blijft staan (knoppen), de CTA gaat uit met de melding "niet leverbaar".
      // r.variant is dan de bestaande combinatie zelf (of dezelfde kleur in een bestaande maat) voor prijs en beeld.
      this.v2Koopbaar = r.koopbaar === true;
      if (r.variant) this.v2Actief = r.variant;
      this.v2Keuze = r.variant ? { maat: r.variant.maat, blad: r.variant.blad, frame: r.variant.frame } : keuze;
      this.#v2Toon(r.melding);
      this.#v2Beeld();
      this.#syncVariant();
      this.#recalcPrice();
      this.#updateBundleContents();
      if (!this.v2Koopbaar) return;
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', String(r.variant.id));
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (err) { /* geen URL-API: alleen de deellink blijft oud */ }
    }

    // V2: hoofdbeeld = combi-beeld van de variant, duimen uit custom.bundel_galerij (SPEC §5.1-f).
    // Alleen als de pagina met een V2-galerij startte ([data-stane-v3-v2-beeld]); anders blijft de productgalerij (B10).
    #v2Beeld() {
      const a = this.v2Actief;
      if (!a || !a.beeld || !this.mainImg || !this.mainImg.hasAttribute('data-stane-v3-v2-beeld')) return;
      if (a.beeld.srcset) {
        this.mainImg.setAttribute('srcset', a.beeld.srcset);
        this.mainImg.setAttribute('sizes', '(max-width: 1023px) 100vw, 50vw');
      } else {
        this.mainImg.removeAttribute('srcset');
        this.mainImg.removeAttribute('sizes');
      }
      this.mainImg.src = a.beeld.src;
      if (a.beeld.alt) this.mainImg.alt = a.beeld.alt;
      const ul = this.querySelector('[data-stane-v3-v2-thumbs]');
      if (!ul) return;
      const galerij = Array.isArray(a.galerij) ? a.galerij : [];
      ul.replaceChildren();
      galerij.forEach((g, i) => {
        const li = document.createElement('li');
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'stane-v3-hero__thumb' + (i === 0 ? ' is-active' : '');
        b.setAttribute('data-stane-v3-thumb', '');
        b.dataset.fullSrc = g.full;
        b.setAttribute('aria-label', 'Toon foto ' + (i + 1));
        const img = document.createElement('img');
        img.src = g.thumb; img.alt = ''; img.loading = 'lazy'; img.width = 240; img.height = 240;
        img.className = 'stane-v3-hero__thumb-img';
        b.appendChild(img); li.appendChild(b); ul.appendChild(li);
        b.addEventListener('click', this.#onThumbClick.bind(this));
      });
      ul.hidden = galerij.length < 2;
      this.thumbs = Array.from(this.querySelectorAll('[data-stane-v3-thumb]'));
    }

    // V2: knoppen (aria-pressed / aria-disabled), gekozen labels, melding, CTA en de zusterlink volgen v2Keuze.
    // Een maat is alleen aan als er in de gekozen kleur een KOOPBARE variant van is (echt + available).
    #v2Toon(melding) {
      const K = window.StaneBundelKeuze;
      const a = this.v2Keuze;
      if (!K || !a) return;
      const echt = this.v2.varianten.filter(v => K.koopbaar(v, this.v2.bestaand)).map(v => v.maat + '|' + v.blad + '|' + v.frame);
      const kleur = a.blad + '|' + a.frame;
      let kleinste = '';
      let grijs = false;
      const maatKnoppen = this.querySelectorAll('[data-stane-v3-optie="afmeting"] [data-waarde]');
      maatKnoppen.forEach(b => {
        if (!kleinste && K.kleurenBijMaat(echt, b.dataset.waarde).indexOf(kleur) !== -1) kleinste = b.dataset.weergave || b.dataset.waarde;
      });
      const tVanaf = this.v2Teksten.vanaf || 'Deze combinatie is er vanaf [maat]';
      const tNiet = this.v2Teksten.nietLeverbaar || 'Deze combinatie is niet leverbaar';
      const uitleg = kleinste ? tVanaf.replace('[maat]', kleinste) : tNiet;
      const cta = this.querySelector('[data-stane-v3-cta]');
      if (cta) { if (this.v2Koopbaar) cta.removeAttribute('aria-disabled'); else cta.setAttribute('aria-disabled', 'true'); }
      this.querySelectorAll('[data-stane-v3-optie]').forEach(groepEl => {
        const veld = groepEl.dataset.staneV3Optie === 'afmeting' ? 'maat' : groepEl.dataset.staneV3Optie;
        let gekozenTekst = '';
        groepEl.querySelectorAll('[data-waarde]').forEach(b => {
          const gedrukt = b.dataset.waarde === a[veld];
          b.setAttribute('aria-pressed', String(gedrukt));
          if (gedrukt) gekozenTekst = b.dataset.weergave || b.dataset.waarde;
          if (veld === 'maat') {
            const bestaat = K.kleurenBijMaat(echt, b.dataset.waarde).indexOf(kleur) !== -1;
            b.setAttribute('aria-disabled', String(!bestaat));
            if (bestaat) b.removeAttribute('title'); else { b.setAttribute('title', uitleg); grijs = true; }
          }
        });
        const gekozenEl = groepEl.querySelector('[data-stane-v3-gekozen]');
        if (gekozenEl && gekozenTekst) gekozenEl.textContent = gekozenTekst;
      });
      const meldEl = this.querySelector('[data-stane-v3-melding]');
      if (meldEl) meldEl.textContent = melding || (grijs ? uitleg : '');
      // Modeltabs: dezelfde maat + blad + frame mee naar het andere model (waar die bestaan)
      this.querySelectorAll('a[data-stane-v3-tab-url]').forEach(l => {
        try {
          const tv = JSON.parse(l.dataset.staneV3TabVarianten || '[]');
          l.setAttribute('href', K.zusterUrl(l.dataset.staneV3TabUrl, tv, a));
        } catch (e) { /* blijft de server-link */ }
      });
      if (this.v2.zuster) {
        this.querySelectorAll('a[data-stane-v3-zitting]').forEach(l => {
          l.setAttribute('href', K.zusterUrl(this.v2.zuster.url, this.v2.zuster.varianten || [], a));
        });
      }
    }

    #onSizeClick(e) {
      const btn = e.currentTarget;
      this.sizeButtons.forEach(b => b.classList.toggle('is-active', b === btn));
      this.#syncVariant();
      this.#recalcPrice();
      this.#updateBundleContents();
    }

    #onChairClick(e) {
      const btn = e.currentTarget;
      this.chairButtons.forEach(b => b.classList.toggle('is-active', b === btn));
      this.#syncVariant();
      this.#recalcPrice();
      this.#updateBundleContents();
    }

    #recalcPrice() {
      const activeSize = this.sizeButtons.find(b => b.classList.contains('is-active'));
      // Variant.price = bron van waarheid; fallback op basePrice + sizeDelta als geen match
      let bundlePriceCents;
      if (this.activeVariant && typeof this.activeVariant.price === 'number') {
        bundlePriceCents = this.activeVariant.price;
      } else {
        const sizeDeltaCents = activeSize ? parseInt(activeSize.dataset.priceDelta || '0', 10) : 0;
        bundlePriceCents = this.basePriceCents + sizeDeltaCents;
      }
      let upsellsTotal = 0;
      this.upsellInputs.forEach(input => {
        if (input.checked) upsellsTotal += parseInt(input.dataset.variantPriceCents || '0', 10);
      });
      const ctaTotal = bundlePriceCents + upsellsTotal;

      // Hero main price = bundle prijs zonder upsells (consistent met bundle-contents bundle-actual)
      const heroMainFmt = this.#formatMoney(bundlePriceCents);
      this.heroMainPriceEls.forEach(el => el.textContent = heroMainFmt);
      // CTA-price = bundle + upsells
      const ctaFmt = this.#formatMoney(ctaTotal);
      this.ctaPriceEls.forEach(el => el.textContent = ctaFmt);
      if (this.exclBtwEl) {
        const exclCents = Math.round(bundlePriceCents / 1.21);
        this.exclBtwEl.textContent = this.#formatMoney(exclCents);
      }
      this.#updateHeroCAP(activeSize, bundlePriceCents);
      // Broadcast voor andere V3-secties (sticky-cta etc.) — non-blocking
      try {
        document.dispatchEvent(new CustomEvent('stane-v3:variant-changed', {
          detail: { sectionId: this.dataset.sectionId || null, v2: this.v2Actief || null }
        }));
      } catch (e) { /* CustomEvent niet beschikbaar — stil falen */ }
    }

    #updateHeroCAP(activeSize, bundlePriceCents) {
      if (!this.heroCapBlock) return;
      const deskCapCents = this.v2
        ? (this.v2Actief?.bureauCap || 0)
        : (activeSize ? parseInt(activeSize.dataset.deskCapCents || '0', 10) : 0);
      const totalCap = this.chairCapCents + deskCapCents;
      const heroSavings = totalCap - bundlePriceCents;
      const visible = totalCap > 0 && heroSavings > 0;
      if (this.heroCompareEl && totalCap > 0) this.heroCompareEl.textContent = this.#formatMoney(totalCap);
      if (this.heroSavingsEl) this.heroSavingsEl.textContent = this.#formatMoney(heroSavings > 0 ? heroSavings : 0);
      this.heroCapBlock.toggleAttribute('hidden', !visible);
    }

    #formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        try { return window.Shopify.formatMoney(cents); } catch (e) {}
      }
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
    }

    #updateBundleContents() {
      const activeSize = this.sizeButtons.find(b => b.classList.contains('is-active'));
      let deskCapCents, deskPriceCents, deskLabel, sizeDeltaCents;
      if (this.v2) {
        // V2: bureau = de configuratorvariant met dezelfde maat + blad + frame (uit de JSON)
        if (!this.v2Actief) return;
        deskCapCents = this.v2Actief.bureauCap || 0;
        deskPriceCents = this.v2Actief.bureauPrice || 0;
        deskLabel = this.v2Actief.maatLabel || '';
        sizeDeltaCents = 0;
      } else {
        if (!activeSize) return;
        deskCapCents = parseInt(activeSize.dataset.deskCapCents || '0', 10);
        deskPriceCents = parseInt(activeSize.dataset.deskPriceCents || '0', 10);
        deskLabel = activeSize.dataset.deskLabel || '';
        sizeDeltaCents = parseInt(activeSize.dataset.priceDelta || '0', 10);
      }

      // Chair CAP is statically rendered in Liquid; read first DOM occurrence as source of truth.
      const chairCapEl = document.querySelector('[data-stane-chair-cap]');
      let chairCapCents = 0;
      if (chairCapEl) {
        chairCapCents = this.#parseMoneyToCents(chairCapEl.textContent);
      }

      // Update desk-cap displays (image-overlay + adviesprijs row + calc-row dd)
      if (deskCapCents > 0) {
        const formatted = this.#formatMoney(deskCapCents);
        document.querySelectorAll('[data-stane-desk-cap]').forEach(el => el.textContent = formatted);
      }

      // Update desk-label across DOM ("(140 x 60 cm)")
      document.querySelectorAll('[data-stane-desk-label]').forEach(el => el.textContent = ' (' + deskLabel + ')');

      // Total CAP
      const totalCap = chairCapCents + deskCapCents;
      if (totalCap > 0) {
        const formatted = this.#formatMoney(totalCap);
        document.querySelectorAll('[data-stane-total-cap]').forEach(el => el.textContent = formatted);
      }

      // Bundle actual = base + size delta (no upsells in CAP-savings calc)
      const bundleActualCents = (this.activeVariant && typeof this.activeVariant.price === 'number')
        ? this.activeVariant.price
        : (this.basePriceCents + sizeDeltaCents);
      document.querySelectorAll('[data-stane-bundle-actual]').forEach(el => el.textContent = this.#formatMoney(bundleActualCents));
      const exclBundleCents = Math.round(bundleActualCents / 1.21);
      document.querySelectorAll('[data-stane-bundle-actual-excl]').forEach(el => el.textContent = this.#formatMoney(exclBundleCents) + ' excl. btw');

      // Savings & pct
      const savings = totalCap - bundleActualCents;
      document.querySelectorAll('[data-stane-bundle-savings]').forEach(el => el.textContent = this.#formatMoney(savings > 0 ? savings : 0));
      const pct = totalCap > 0 ? Math.round((savings / totalCap) * 100) : 0;
      document.querySelectorAll('[data-stane-bundle-savings-pct]').forEach(el => el.textContent = pct);
      document.querySelectorAll('[data-stane-bundle-savings-bar]').forEach(el => { el.style.width = (pct > 0 ? pct : 0) + '%'; });

      // Hide entire savings block if savings <= 0
      const savingsBlock = document.querySelector('[data-stane-savings-block]');
      const progressBar = savingsBlock?.parentElement?.querySelector('.stane-v3-bc__calc-progress');
      const progressLabel = savingsBlock?.parentElement?.querySelector('.stane-v3-bc__calc-progress-label');
      const showBlock = savings > 0;
      if (savingsBlock) savingsBlock.toggleAttribute('hidden', !showBlock);
      if (progressBar) progressBar.toggleAttribute('hidden', !showBlock);
      if (progressLabel) progressLabel.toggleAttribute('hidden', !showBlock);
    }

    async #handleSubmit(event) {
      if (event && event.preventDefault) event.preventDefault();
      if (event && event.stopImmediatePropagation) event.stopImmediatePropagation();
      if (event && event.stopPropagation) event.stopPropagation();

      // SCOPE-GUARD: alleen actief als event binnen DEZE custom element gebeurt
      if (event && event.target && !this.contains(event.target)) {
        return;
      }

      // V2: een niet-koopbare keuze (CTA aria-disabled) post niets; de melding staat al in de live region
      if (this.v2 && !this.v2Koopbaar) return;

      // Eénmaal-flag: voorkomt dubbele triggers (form-submit + button-click op zelfde gebaar)
      if (this.__cartSubmitting) return;
      this.__cartSubmitting = true;

      const cta = this.querySelector('[data-stane-v3-cta]');
      const originalCtaText = cta?.textContent;
      if (cta) { cta.disabled = true; cta.textContent = 'Toevoegen...'; }

      try {
        // Re-resolve variant op submit-moment (defensief tegen state-drift)
        this.#syncVariant();
        const variantInput = this.querySelector('input[name="id"]');
        const bundleVariantId = variantInput ? variantInput.value : null;

        const items = [];
        if (bundleVariantId) {
          items.push({ id: parseInt(bundleVariantId, 10), quantity: 1 });
        }

        // Upsells: alle aangevinkte [data-stane-v3-upsell] inputs binnen DEZE section
        const upsellInputs = this.querySelectorAll('[data-stane-v3-upsell]:checked');
        upsellInputs.forEach(input => {
          const id = input.dataset.variantId;
          if (id && id !== bundleVariantId) {
            items.push({ id: parseInt(id, 10), quantity: 1 });
          }
        });

        if (items.length === 0) {
          console.warn('[stane-v3-cart] geen items om toe te voegen');
          this.__cartSubmitting = false;
          if (cta) { cta.disabled = false; cta.textContent = originalCtaText; }
          return;
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (response.ok) {
          // Winkelwagenlade zoals bij de losse producten (theme-instellingen cart_type + after_add_to_cart = drawer);
          // anders, of zonder lade op de pagina, naar /cart zoals voorheen.
          if (this.#openCartDrawer(cta)) {
            if (cta) { cta.disabled = false; cta.textContent = originalCtaText; }
            return;
          }
          window.location.href = '/cart';
          return;
        }

        const errBody = await response.json().catch(() => ({}));
        console.error('[stane-v3-cart] add failed:', errBody);
        // Fallback: standaard form-submit zodat klant niet vast komt te zitten
        const form = this.querySelector('[data-stane-v3-cart-form]');
        if (form) {
          form.removeAttribute('data-stane-v3-cart-form');
          HTMLFormElement.prototype.submit.call(form);
        }
      } catch (err) {
        console.error('[stane-v3-cart] fetch error:', err);
        // Bij netwerkfout: stuur klant alsnog naar /cart (kan zijn dat add wel slaagde)
        window.location.href = '/cart';
      } finally {
        this.__cartSubmitting = false;
      }
    }

    /* Opent Symmetry's cart-drawer na een eigen /cart/add.js (patroon custom-bureau-v2.js): on:cart:change laat de
       lade zichzelf verversen; open pas na on:cart:after-merge (vangnet 1200 ms), een open lade niet opnieuw. */
    #openCartDrawer(opener) {
      const s = window.theme && theme.settings;
      if (!s || s.cartType !== 'drawer' || s.afterAddToCart !== 'drawer') return false;
      const lade = document.querySelector('.js-cart-drawer');
      if (!lade) return false;
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true }));
      let gedaan = false;
      let timer = null;
      const open = () => {
        if (gedaan) return;
        gedaan = true;
        clearTimeout(timer);
        if (lade.hasAttribute('open')) return;
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, cancelable: false, detail: { opener: opener || null } }));
      };
      const vorm = lade.querySelector('cart-form');
      if (vorm) vorm.addEventListener('on:cart:after-merge', open, { once: true });
      timer = setTimeout(open, 1200);
      return true;
    }

    #parseMoneyToCents(text) {
      if (!text) return 0;
      // Strip everything except digits, comma, dot. Then normalize to cents.
      const cleaned = text.replace(/[^0-9,.\-]/g, '').replace(',', '.');
      const value = parseFloat(cleaned);
      if (isNaN(value)) return 0;
      return Math.round(value * 100);
    }
  }
  // Guard tegen dubbele definitie (template kan in dev meerdere keren parsen)
  if (!customElements.get('stane-v3-hero-controller')) {
    customElements.define('stane-v3-hero-controller', StaneV3HeroController);
  }

  // V3-namespace voor andere V3-secties (sticky-cta, etc.) om hero-state te lezen
  // en cart-submit via dezelfde triple-defense te triggeren.
  window.staneV3 = window.staneV3 || {};
  window.staneV3.getActiveHero = function() {
    return document.querySelector('stane-v3-hero-controller');
  };
  window.staneV3.submitCart = function() {
    const hero = window.staneV3.getActiveHero();
    if (!hero) {
      console.warn('[stane-v3] geen hero gevonden voor cart-submit');
      return false;
    }
    const cta = hero.querySelector('[data-stane-v3-cta]');
    if (!cta) return false;
    cta.click(); // triggert vangnet 2 (button click capture) van hero
    return true;
  };
  window.staneV3.getCurrentPrice = function() {
    const hero = window.staneV3.getActiveHero();
    if (!hero) return null;
    return {
      deal: hero.querySelector('[data-stane-v3-total-price]')?.textContent?.trim() || null,
      los: hero.querySelector('[data-stane-v3-hero-compare]')?.textContent?.trim() || null,
      savings: hero.querySelector('[data-stane-v3-hero-savings]')?.textContent?.trim() || null,
      capVisible: !hero.querySelector('[data-stane-v3-hero-cap-block]')?.hasAttribute('hidden'),
    };
  };

  // UGC inline play — klik op trigger → poster verdwijnt, video speelt in tile
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest?.('[data-stane-v3-ugc-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const tile = trigger.closest('[data-stane-v3-ugc-tile]');
    const video = tile?.querySelector('[data-stane-v3-ugc-video]');
    if (!video) return;
    trigger.hidden = true;
    video.hidden = false;
    const playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(err => console.warn('[stane-v3-ugc] autoplay blocked:', err));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stane-v3-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  class StaneV3StickyCta extends HTMLElement {
    connectedCallback() {
      // Visibility scroll-toggle (zoals voorheen)
      this.onScroll = () => {
        const visible = window.scrollY > 600;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      // Price-sync met hero
      this.dealEl = this.querySelector('[data-stane-v3-sticky-deal]');
      this.losEl = this.querySelector('[data-stane-v3-sticky-los]');
      this.savingsEl = this.querySelector('[data-stane-v3-sticky-savings]');
      this.onVariantChanged = this.#syncPrice.bind(this);
      document.addEventListener('stane-v3:variant-changed', this.onVariantChanged);
      this.#syncPrice(); // initial sync

      // Cart-submit delegate naar hero (triple-defense pad)
      const form = this.querySelector('[data-stane-v3-sticky-form]');
      const cta = this.querySelector('[data-stane-v3-sticky-cta]');
      const delegate = (e) => {
        if (!window.staneV3 || typeof window.staneV3.submitCart !== 'function') {
          console.warn('[stane-v3-sticky] staneV3.submitCart ontbreekt; fallback naar standaard form-submit');
          return; // laat browser default-submit doen
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        window.staneV3.submitCart();
      };
      if (form) form.addEventListener('submit', delegate, { capture: true });
      if (cta) cta.addEventListener('click', delegate, { capture: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.onVariantChanged) {
        document.removeEventListener('stane-v3:variant-changed', this.onVariantChanged);
      }
    }

    #syncPrice() {
      if (!window.staneV3 || typeof window.staneV3.getCurrentPrice !== 'function') return;
      const p = window.staneV3.getCurrentPrice();
      if (!p) return;
      if (this.dealEl && p.deal) this.dealEl.textContent = p.deal;
      // CAP en savings: alleen tonen als hero CAP-block zichtbaar is
      const showCap = p.capVisible && p.los && p.savings;
      if (this.losEl) {
        if (showCap) { this.losEl.textContent = p.los; this.losEl.hidden = false; }
        else { this.losEl.hidden = true; }
      }
      if (this.savingsEl) {
        if (showCap) { this.savingsEl.textContent = '-' + p.savings; this.savingsEl.hidden = false; }
        else { this.savingsEl.hidden = true; }
      }
    }
  }
  if (!customElements.get('stane-v3-sticky-cta')) {
    customElements.define('stane-v3-sticky-cta', StaneV3StickyCta);
  }

  } catch(e) { console.error(e); }
})();
})();
